import { Stack } from "@altimateai/lego";
import { Button, Card, CardContent, Typography } from "@altimateai/lego";
import { IconFileText, IconPuzzle } from "@tabler/icons-react";
import { Link } from "react-router-dom";
import { dropdownMenuData, PathOption, pathConfigs } from "../../constants";
import Dropdown from "../dropdown/Dropdown";

const dbtConfig = pathConfigs[PathOption.Dbt];
const dbtDropdowns = dropdownMenuData[PathOption.Dbt];

function DbtSection() {
  const [firstDropdown, ...featureDropdowns] = dbtDropdowns;

  return (
    <Card
      className="al-rounded-xl al-py-8 al-px-4 !al-bg-white"
      aria-label="Power User for dbt content"
    >
      <CardContent>
        <Stack direction="column" gap="xl">
          <Stack direction="column">
            <Typography variant="h4" weight="semibold" className="al-text-gray-900">
              Get Started with Power User for dbt
            </Typography>
            <Typography size="sm" className="al-text-gray-600">
              Supercharge your dbt development workflow in VS Code
            </Typography>
          </Stack>
          <Stack gap="sm" direction="column" className="al-py-2 sm:al-flex-row">
            <Button
              size="lg"
              className="al-bg-slate-900 hover:al-bg-slate-800 al-py-7 al-px-8 al-text-base al-w-full sm:al-w-auto"
              asChild
            >
              <Link to="https://docs.myaltimate.com/" target="_blank" rel="noopener noreferrer">
                <IconFileText size={18} />
                View Documentation
              </Link>
            </Button>
            <Button
              size="lg"
              className="al-bg-slate-900 hover:al-bg-slate-800 al-py-7 al-px-8 al-text-base al-w-full sm:al-w-auto"
              asChild
            >
              <Link
                to="https://marketplace.visualstudio.com/items?itemName=innoverio.vscode-dbt-power-user"
                target="_blank"
                rel="noopener noreferrer"
              >
                <IconPuzzle size={18} />
                Install Extension
              </Link>
            </Button>
          </Stack>
          <Stack direction="column" gap="md" className="al-space-y-2">
            <Dropdown
              stepNumber="1"
              title={firstDropdown.title}
              subtitle={firstDropdown.subtitle}
              tutorial={firstDropdown.tutorial}
              borderColor={dbtConfig.borderColor}
              bgColor={dbtConfig.bgColor}
            />

            <Typography
              size="sm"
              className="al-text-gray-700 al-mt-6 al-mb-3 al-px-2 al-font-medium"
            >
              Key Features
            </Typography>

            {featureDropdowns.map((item, index) => (
              <Dropdown
                key={item.title}
                stepNumber={String(index + 2)}
                title={item.title}
                subtitle={item.subtitle}
                tutorial={item.tutorial}
                borderColor={dbtConfig.borderColor}
                bgColor={dbtConfig.bgColor}
              />
            ))}
          </Stack>
        </Stack>
      </CardContent>
      <Stack
        direction="column"
        align="center"
        justify="center"
        className="al-bg-orange-50 al-p-6 al-w-full al-text-center"
      >
        <Typography variant="section-heading" className="al-text-gray-900 al-mb-1">
          All set! Start using Power User for dbt
        </Typography>
        <Typography size="sm" className="al-text-gray-600">
          Open your dbt project in VS Code to see the extension in action
        </Typography>
      </Stack>
    </Card>
  );
}

export { DbtSection };
